import { useContext } from 'react';

import { EnvironmentContext } from '../EnvironmentProvider';

const useEnvironment = () => useContext(EnvironmentContext);
export default useEnvironment;
